import * as React from 'react';

import {
  BellFilled,
  Button,
  ButtonType,
  Column,
  Row,
  Space,
  Text,
} from 'farmhub-ui-core';

import { theme } from 'styled';

import {
  CModal,
  ModalStyles,
  Wrapper,
  WrapperContent,
  WrapperIcon,
} from './styles';

interface ConfirmModalProps {
  isVisible: boolean;

  title?: string;
  message?: React.ReactNode;
  name?: string | React.ReactNode;
  isLoading?: boolean;
  haveLoading?: boolean;
  okText?: string;
  children?: React.ReactNode;
  bodyPadding?: string;
  hideIcon?: boolean;
  hideIconClose?: boolean;
  onOke?: () => void;
  onCancel?: () => void;
  setIsVisible: (e: boolean) => void;
}

const ConfirmModal = ({
  name,
  title,
  message,
  isVisible,
  isLoading,
  haveLoading = false,
  okText,
  children,
  bodyPadding = '24px',
  hideIcon = false,
  hideIconClose = false,
  onOke,
  onCancel,
  setIsVisible,
}: ConfirmModalProps): JSX.Element => (
  <Wrapper onClick={(e: any) => e.stopPropagation()}>
    <CModal
      centered
      bodyHeight="340px"
      bodyPadding={bodyPadding}
      hideIconClose={hideIconClose}
      maskClosable={false}
      styles={ModalStyles}
      visible={isVisible}
      width="480px"
      onCancel={() => {
        onCancel && onCancel();
        setIsVisible(false);
      }}
    >
      <WrapperContent>
        <Column alignItems="center" styles={{ gap: 8, height: '100%' }}>
          {!hideIcon && (
            <Column alignItems="center" styles={{ paddingBottom: 8 }}>
              <WrapperIcon>
                <BellFilled style={{ fontSize: 48 }} />
              </WrapperIcon>
            </Column>
          )}
          <Column alignItems="center" styles={{ gap: 4 }}>
            <Text
              color="primary"
              size="xs"
              style={{ textAlign: 'center' }}
              textTransform="uppercase"
              weight="extraBold"
            >
              {title}
            </Text>
            <Text style={{ textAlign: 'center' }} weight="medium">
              {message}
            </Text>
            {typeof name === 'string' ? (
              <Text style={{ textAlign: 'center' }} weight="medium">
                {name}
              </Text>
            ) : (
              name
            )}
          </Column>

          {children}
          <Space height={2} />
          <Row justifyContent="center" styles={{ gap: 12 }}>
            {onCancel && (
              <Button
                disabled={isLoading}
                height={theme.button.height.md}
                type={ButtonType.Default}
                width="108px"
                onClick={() => {
                  if (onCancel) {
                    onCancel();
                  }
                  setIsVisible(false);
                }}
              >
                Hủy bỏ
              </Button>
            )}
            {onOke && (
              <Button
                height={theme.button.height.md}
                loading={isLoading}
                type={ButtonType.Primary}
                width="108px"
                onClick={() => {
                  if (onOke) {
                    onOke();
                  }
                  !haveLoading && setIsVisible(false);
                }}
              >
                {okText || 'Xác nhận'}
              </Button>
            )}
          </Row>
        </Column>
      </WrapperContent>
    </CModal>
  </Wrapper>
);

export default ConfirmModal;
